import { Component } from "@ecs/Component";
import * as RAPIER from '@dimforge/rapier3d-compat'
export class Joint extends Component {
    joint!: RAPIER.ImpulseJoint
    buildData: any
    setup(_data: any) {
        this.buildData = _data
    }
    start() {
        const _data: { params: RAPIER.JointData, body1: { body: RAPIER.RigidBody }, body2: { body: RAPIER.RigidBody } } = this.buildData
        _data.params = _data.params || RAPIER.JointData.spherical({ x: 0.5, y: 0.0, z: 1.0 }, { x: 0.0, y: 0, z: 0 });

        //_data.body1.body.collider(0).setRotation(_data.body1.body.rotation())
        //_data.body2.body.collider(0).setRotation(_data.body2.body.rotation())
        this.joint = this.scene.physicsWorld.createImpulseJoint(_data.params, _data.body1.body, _data.body2.body, false);
        this.joint.setContactsEnabled(false);

    }
    update(_dt: number) {
        //console.log((this.buildData.body1.body as RAPIER.RigidBody).rotation(), (this.buildData.body2.body as RAPIER.RigidBody).rotation())

    }
    onMove() {

    }
    onDestroy() {
        this.scene.physicsWorld.removeImpulseJoint(this.joint, true)
    }
}
